"use strict";

exports.isLocaleSupported = isLocaleSupported;
var _locales = require("./locales");
function isLocaleSupported(code) {
  return _locales.locales.indexOf(code) >= 0;
}